<script>
    import { fly } from 'svelte/transition';

    import { addListernEvent } from "api/functions";
    
    let 
        visible = false,
        warType,
        warGripType,
        weaponType,
        title, 
        time, 
        attackName, 
        protectingName, 
        attackingCount, 
        protectingCount,
        attackingPlayersInZone, 
        protectingPlayersInZone;

    addListernEvent ("hud.war.open", (_warType, _warGripType, _weaponType, _title, _attackName, _protectingName) => {
        weaponType = _weaponType;
        warType = _warType;
        warGripType = _warGripType;
        title = _title;
        attackName = _attackName;
        protectingName = _protectingName;
        visible = true;
    });

    addListernEvent ("hud.war.update", (type, value1, value2) => {
        if (type === "count") {
            attackingCount = value1;
            protectingCount = value2;
        }

        if (type === "playersCount") {
            attackingPlayersInZone = value1;
            protectingPlayersInZone = value2;
        }

        if (type === "time") {
            time = value1;
        }
    });

    addListernEvent ("hud.war.close", () => {
        visible = false;
        attackingPlayersInZone = 0;
        protectingPlayersInZone = 0;
        attackingCount = 0;
        protectingCount = 0;
    });

    import { typeBattle, weaponsCategory } from '@/popups/war/data'

    const getProgress = (value, max) => {
        if (!max)
            return 50;
            
        return 100 / max * value;
    }

</script>

{#if visible}
    <div class="magiccapt">
        <div class="captleft">
            <img src="http://cdn.magicfive.ru/haxzer/magichud/{protectingName}.png" alt="">
            <b>{protectingCount}</b>
        </div>
        <div class="captcenter">
            <p>{time}</p>
        </div>
        <div class="captright">
            <b>{attackingCount}</b>
            <img src="http://cdn.magicfive.ru/haxzer/magichud/{attackingCount}.png" alt="">
        </div>
    </div>
{/if}